 function _optionalChain(ops) { let lastAccessLHS = undefined; let value = ops[0]; let i = 1; while (i < ops.length) { const op = ops[i]; const fn = ops[i + 1]; i += 2; if ((op === 'optionalAccess' || op === 'optionalCall') && value == null) { return undefined; } if (op === 'access' || op === 'optionalAccess') { lastAccessLHS = value; value = fn(value); } else if (op === 'call' || op === 'optionalCall') { value = fn((...args) => value.call(lastAccessLHS, ...args)); lastAccessLHS = undefined; } } return value; }import graphql from 'babel-plugin-relay/macro'
import {commitMutation} from 'react-relay'



import getDiscussionThreadConn from './connections/getDiscussionThreadConn'

graphql`
  fragment ResetRetroMeetingToGroupStageMutation_meeting on ResetRetroMeetingToGroupStagePayload {
    meeting {
      id
      phases {
        id
        stages {
          id
          isComplete
          isNavigable
          isNavigableByFacilitator
        }
      }
      ... on RetrospectiveMeeting {
        viewerMeetingMember {
          id
          votesRemaining
        }
        votesRemaining
        reflectionGroups {
          id
          meetingId
          viewerVoteCount
        }
      }
      ...MeetingControlBar_meeting
    }
  }
`

const mutation = graphql`
  mutation ResetRetroMeetingToGroupStageMutation($meetingId: ID!) {
    resetRetroMeetingToGroupStage(meetingId: $meetingId) {
      error {
        message
      }
      ...ResetRetroMeetingToGroupStageMutation_meeting @relay(mask: false)
    }
  }
`

export const resetRetroMeetingToGroupStageUpdater

 = (payload, {store}) => {
  const meeting = payload.getLinkedRecord('meeting')
  if (!meeting) return
  const phases = meeting.getLinkedRecords('phases')
  if (!phases) return
  const discussPhase = phases.find((phase) => _optionalChain([phase, 'optionalAccess', _ => _.getValue, 'call', _2 => _2('phaseType')]) === 'discuss')
  if (!discussPhase) return
  const stages = discussPhase.getLinkedRecords('stages')
  stages.forEach((stage) => {
    const discussionId = _optionalChain([stage, 'optionalAccess', _3 => _3.getValue, 'call', _4 => _4('discussionId')]) 
    const thread = getDiscussionThreadConn(store, discussionId)
    _optionalChain([thread, 'optionalAccess', _5 => _5.setLinkedRecords, 'call', _6 => _6([], 'edges')])
  })
}

const ResetRetroMeetingToGroupStageMutation

 = (atmosphere, variables) => {
  return commitMutation(atmosphere, {
    mutation,
    updater: (store) => {
      const payload = store.getRootField('resetRetroMeetingToGroupStage')
      if (!payload) return
      resetRetroMeetingToGroupStageUpdater(payload, {store, atmosphere})
    },
    variables
  })
}

export default ResetRetroMeetingToGroupStageMutation
